module.exports = __webpack_public_path__ + "static/media/yijianbaojing.90796c4.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/yijianbaojing.wav
// module id = FVYx
// module chunks = 208